import React, { useContext } from 'react';
import { FormControl, InputLabel } from '@material-ui/core';

import { RichTextEditor } from '@klpkonsern/ui';

import { FormContext } from './FormContext';
import './FormEditor.scss';
import { useFormField, type IFormFieldProps } from './useFormField';

export const FormEditor: React.FC<IFormFieldProps<string>> = (props) => {
    const { name, title } = props;

    const { hasError, handleChange, formValue } = useFormField<string>(props);
    const context = useContext(FormContext);

    const valueChange = (value: string) => {
        const { validators } = props;
        handleChange(name, validators)(value);
    };

    return (
        <FormControl
            error={hasError()}
            className="Form__Field Form__Editor"
            disabled={context.formDisabled}
        >
            <InputLabel shrink={true}>{title}</InputLabel>
            <RichTextEditor
                enableSourceEditing={true}
                enableTables={true}
                initialContent={formValue as string}
                onContentChange={valueChange}
            />
        </FormControl>
    );
};
